import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import {
  type FilterChipEditContext,
  type FilterItem,
  type ObjectSearchRequest,
} from '@bizzdesign/data-access-search';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import type { AttributeCategoryDefinitionDto } from '@bizzdesign/shared/models';
import { ButtonModule } from 'primeng/button';
import { InteractiveFilterChipComponent } from '../interactive-filter-chip/interactive-filter-chip.component';

/**
 * Renders the applied filters as interactive chips (see
 * {@link InteractiveFilterChipComponent}) with a trailing "clear all" action.
 *
 * @remarks Presentational only. It relays each chip's value edit, removal and
 * typeahead searches to the container, which owns the filter state. The classic
 * `AppliedFiltersComponent` is kept for read-only consumers; this component is the
 * editable variant used by the search containers.
 */
@Component({
  selector: 'bd-interactive-applied-filters',
  imports: [ButtonModule, SharedI18nModule, InteractiveFilterChipComponent],
  templateUrl: './interactive-applied-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InteractiveAppliedFiltersComponent {
  filters = input<FilterItem[]>([]);
  attributeCategoryDefinitions = input<AttributeCategoryDefinitionDto[]>([]);
  editContext = input<FilterChipEditContext>();
  disabled = input<boolean>(false);

  updateFilter = output<FilterItem>();
  removeFilter = output<FilterItem>();
  clearAllFilters = output<void>();
  searchObjects = output<ObjectSearchRequest>();
  searchUsers = output<string>();

  removeAllFilters(): void {
    this.clearAllFilters.emit();
  }
}
